import(/* webpackMode: "eager" */ "/app/app/(private)/(dashboard-shell)/(chat-shell)/layout.tsx");
